import './menubar.css'
import { MdAppRegistration } from "react-icons/md";

function Menubar(){
return(
    <div>
        <nav className="navbar navbar-expand-lg bg-body-tertiary" id='bg-color'>
          <div className="container-fluid">
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse bg text" id="navbarNavDropdown">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a className="nav-link silver" aria-current="page" href="/"><i className="fas fa-home"></i>&nbsp;HOME</a>
                  {/* <a className="nav-link active" aria-current="page" href="#">Home</a> */}
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/about-us"><i className="fas fa-users"></i>&nbsp;ABOUT US</a>
                </li>
                <li className="nav-item dropdown">
                  <button className="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-laptop-code"></i>
                    &nbsp;COURSE
                  </button>
                  <ul className="dropdown-menu">
                    <li><a className="dropdown-item" href="/coursedetails/ms-Office">MS OFFICE</a></li>
                    <li><a className="dropdown-item" href="/coursedetails/dtp">DTP</a></li>
                    <li><a className="dropdown-item" href="/coursedetails/c-language">C-LANGUAGE</a></li>
                    <li><a className="dropdown-item" href="/coursedetails/video-editing">VIDEO EDITING</a></li>
                    <li><a className="dropdown-item" href="/coursedetails/tally">TALLY</a></li>
                    <li><a className="dropdown-item" href="/coursedetails/html">HTML</a></li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/student-works"><i className="fas fa-user-graduate"></i>&nbsp;STUDENT WORKS</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/contact-us"><i className="far fa-address-book"></i>&nbsp;CONTACT</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/register-now"><MdAppRegistration style={{fontSize: '1.5em'}}/>&nbsp;Registration</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
  
       </div>
);
}

export default Menubar